import "./Footer.css"

export default function Footer() {
    return (
        <div className="footer">
            <div className="created-by">
                Created By: <a href="mailto:[limlyang121@outlook.com]">Edy Kelvianto</a> | Contact: +6592777067 / +6285356231234
            </div>
        </div>
    )
} 